import React, { useContext } from "react";
import VariantOptionRadio from "./VariantOptionRadio";
import { TemplateContext } from "../../layout";
import SizeChart from "../SizeChart.jsx";

const VariantsPickerSeparate = () => {
  const [templateContext, setTemplateContext, variantsContext, setVariantsContext] = useContext(TemplateContext);
  const variantsBase = window.post_template?.checkout_v4_products;
  const sizeChartLabel = variantsBase?.tr_checkout_v4_sizeChartLabel;
  const sizeChartLink = variantsBase?.checkout_v4_sizeChartLink;

  const handleColorChange = (sku, label) => {
    setVariantsContext({
      ...variantsContext,
      variants: variantsContext?.variants.map((item) => {
        return {
          ...item,
          color: sku,
          colorLabel: label,
        };
      }),
    });
  };

  const handleSizeChange = (sku, label) => {
    setVariantsContext({
      ...variantsContext,
      variants: variantsContext?.variants.map((item) => {
        return {
          ...item,
          size: sku,
          sizeLabel: label,
        };
      }),
    });
  };

  const heading = window?.post_template.checkout_v4_products?.tr_checkout_v4_bundleVariantHeading;

  return (
    <section className="variants-container--radio">
      <div className="variants-container--separate-picker">
        {heading && <h3 className="productPackages__heading">{heading}</h3>}
        <SizeChart sizeChartLink={sizeChartLink} sizeChartLabel={sizeChartLabel} />
      </div>
      <div className="variants-container__wrapper">
        {window?.productData?.product_size_variants?.length > 0 && window.productData?.enable_size_variants && (
          <>
            <div className="variant-container--radio">
              {window.productData?.product_size_variants.map((variant, index) => (
                <VariantOptionRadio
                  key={index}
                  label={variant.tr_label}
                  sku={variant.value}
                  type="size"
                  size={window.productData?.product_size_variants?.length}
                  handleClick={(sku, label) => {
                    handleSizeChange(sku, label);
                  }}
                />
              ))}
            </div>
          </>
        )}
        {window?.productData?.product_color_variants.length > 0 && window.productData?.enable_color_variants && (
          <>
            <div className="variant-container--radio">
              {window.productData.product_color_variants.map((variant, index) => (
                <VariantOptionRadio
                  key={index}
                  label={variant?.tr_label}
                  sku={variant.value}
                  type="color"
                  color={variant?.color_hex}
                  size={window.productData?.product_color_variants?.length}
                  handleClick={(sku, label) => {
                    handleColorChange(sku, label);
                  }}
                />
              ))}
            </div>
          </>
        )}
      </div>
    </section>
  );
};

export default VariantsPickerSeparate;
